import { render, staticRenderFns } from "./LedgerDetails.vue?vue&type=template&id=7294111f&scoped=true"
import script from "./LedgerDetails.vue?vue&type=script&lang=ts"
export * from "./LedgerDetails.vue?vue&type=script&lang=ts"
import style0 from "./LedgerDetails.vue?vue&type=style&index=0&id=7294111f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7294111f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7294111f')) {
      api.createRecord('7294111f', component.options)
    } else {
      api.reload('7294111f', component.options)
    }
    module.hot.accept("./LedgerDetails.vue?vue&type=template&id=7294111f&scoped=true", function () {
      api.rerender('7294111f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ledgers/components/LedgerDetails.vue"
export default component.exports